import { useContext } from 'react';

import TabsContext from './tabs.context';

function useTab() {
  const context = useContext(TabsContext);

  if (!context) {
    throw new Error('useTab must be used within TabsContext');
  }

  return context;
}

export default useTab;